import './LessonTile.scss';

import { DefaultRoutes } from 'Routes';
import { Lesson } from 'types/lessons';
import LessonTileProgressBar from './LessonTileProgressBar/LessonTileProgressBar';
import { Link } from 'react-router-dom';
import { ReactComponent as OpenBook } from '../../images/icons/OpenBook.svg';
import TileOverlay from '../TileOverlay/TileOverlay';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

type LessonTileProps = {
  lesson: Lesson;
  lessonNumber: number;
  color: string;
  courseId: string;
  sectionTitle?: string;
  bookIcon?: boolean;
  isModulesAndTests?: boolean;
  isPrevLessonDone?: boolean | null;
  comingSoon?: boolean;
};

export const LessonTile = observer(
  ({
    lesson,
    lessonNumber,
    color,
    courseId,
    sectionTitle,
    bookIcon = false,
    isModulesAndTests = false,
    isPrevLessonDone,
    comingSoon,
  }: LessonTileProps) => {
    const ps = useStores().profileStore;
    const { progress, title, prerequisites, certification } = lesson;
    const isDisabled = !isPrevLessonDone && prerequisites && prerequisites.length > 0;
    const progressPercentage = Math.floor(progress * 100);
    let tileLink = `${courseId}/${lesson.id}`;
    const { t } = useTranslation();

    if (isDisabled || comingSoon || (certification && !ps.isUserMember)) tileLink = '';
    if (certification && !ps.isUserMember) tileLink = DefaultRoutes.Certifications;

    let overlayText = '';
    if (isDisabled || (certification && ps.isUserMember))
      overlayText = t('PleaseTakeXCourseFirst', { ns: 'modulesAndTests', courseTitle: prerequisites?.toString() });
    if (certification && !ps.isUserMember) overlayText = t('PremiumNeeded', { ns: 'modulesAndTests' });

    return (
      <div
        className={`lesson-tile ${isDisabled || (!ps.isUserMember && isModulesAndTests && certification) ? 'disabled' : ''} ${
          comingSoon ? 'coming-soon' : ''
        }`}
        style={{ backgroundColor: `${color}20` }}
      >
        <Link to={tileLink} state={{ sectionTitle, lessonNumber }}>
          {(certification && !ps.isUserMember) || isDisabled ? (
            <TileOverlay
              color={color}
              overlayText={overlayText}
              descriptionClassNames={`${!ps.isUserMember && certification ? 'certification' : ''}`}
            />
          ) : (
            <></>
          )}
          <div className='lesson-description'>
            <div className='lesson-top-description'>
              <div className='lesson-number' style={{ color: `${color}` }}>
                {lessonNumber}
              </div>
              {bookIcon && <OpenBook style={{ fill: `${color}40` }} />}
            </div>
            <div className='title'>{title.toLowerCase()}</div>
          </div>
          {comingSoon ? (
            <div className='coming-soon-info'>
              <span style={{ color: color }}>{t('ComingSoon', { ns: 'landingPage' })}</span>
            </div>
          ) : (
            <LessonTileProgressBar progress={progressPercentage} color={color} />
          )}
        </Link>
      </div>
    );
  }
);

export default LessonTile;
